import { environment } from "src/environments/environment"

export const supportUrlStructure = function(url, id, contextId?): string{
    let newurl 
    // let newurl = url
    try{
        if(url ){
            if(url.includes('https://') || url.includes('http://') || url.includes('pass://') || url.includes('tridy://') || url.includes('context://')){
                const imgUrl = new URL(url)
                let hostname = environment.urlHostName
                const isEmulator = environment.useEmulators
                if(imgUrl){
                    if(imgUrl.protocol=="pass:" ){
                        const parts = url.match(/pass:\/\/(.+)\/(.+)/)
                        if(parts){
                            const passTemplateID = parts[1]
                            const path = parts[2]
                            const firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
                            newurl=firebaseUrl
                            if(isEmulator){
                                const firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
                                newurl=firebaseUrl
                            }
                        }else{
                            const newparts = url.match(/pass:\/\/(.+)/)
                            if(newparts){
                                let firebaseUrl = `https://${hostname}/v1/pass/${id}`
                                if(isEmulator)
                                    firebaseUrl = `http://localhost:5000/v1/pass/${id}`
                                
                                newparts.forEach( (part,index)=> {
                                    if(index>0){
                                        firebaseUrl += '/' + part 
                                    }
                                })
                                newurl=firebaseUrl
                            }
                        }
                        
                    }
                
                    if(imgUrl.protocol =="tridy:"){
                        const parts = url.match(/tridy:\/\/(.+)\/(.+)/)
                        let path =""
                        if(parts){
                            parts.forEach((parte, index) =>{
                                if(index>0 && index<parts.length){
                                    path += "/" + parte
                                }
                            })
                            let firebaseUrl = `https://${hostname}/v1/pass/${id}/`
                            if(isEmulator)
                                firebaseUrl = `http://localhost:5000/v1/pass/${id}/`
    
                            newurl=firebaseUrl
                        } else {
                            const newparts = url.match(/tridy:\/\/(.+)/)
                            if(newparts){
                                let firebaseUrl = `https://${hostname}/v1/pass/${id}`
                                if(isEmulator)
                                    firebaseUrl = `http://localhost:5000/v1/pass/${id}`
                                
                                newparts.forEach( (part,index)=> {
                                    if(index>0){
                                        firebaseUrl += '/' + part 
                                    }
                                })
                                newurl=firebaseUrl
                            }
                        }
                    }
                
                    if(imgUrl.protocol == "https:" && imgUrl.host == "firebasestorage.googleapis.com"){
                        const parts = url.match(/https:\/\/firebasestorage.googleapis.com(.+)/)
                        const host = imgUrl.pathname.match(/narravero-eu-dev/)
                        const passes = imgUrl.pathname.match(/(.+)passes(.+)/)
                        const info = passes[2].split("%2F")
                        const passTemplateID = info[1]
                        const path = info[2]
                        const name = decodeURI(info[2])
                        let firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
                        if(isEmulator)
                            firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
                        newurl=firebaseUrl
                    }
        
                    if(imgUrl.protocol == "context:"){
                        const parts = url.match(/context:\/\/(.+)\/(.+)/)
                        let path =""
                        parts.forEach((parte, index) =>{
                            if(index>0 && index<parts.length){
                                path += "/" + parte
                            }
                        })
                        let firebaseUrl = `https://${hostname}/v1/context/${contextId}${path}`
                        if(isEmulator)
                            firebaseUrl = `http://localhost:5000/v1/context/${contextId}${path}`
                        newurl=firebaseUrl
                    }

                    if(imgUrl.protocol == "https:"){
                        newurl=imgUrl.href
                    }
                }
            }else{
                const imgUrl = new URL(url)
                newurl = imgUrl
            }
        }
    }catch(e){
        console.log(e)
    }

    return newurl
}
